import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import NumericKeypad from './NumericKeypad';
import './EditItemModal.css';
import { useTranslation } from '../../context/LanguageContext';

const EditItemModal = ({ item, onClose, onSave, mode }) => {
  const { t, isRTL } = useTranslation();
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    if (!value) return;
    
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue <= 0) return;

    if (mode === 'quantity') {
      // For quantity, we still use integer values
      onSave({ ...item, quantity: Math.floor(numericValue) });
    } else {
      // For price, we allow up to 2 decimal places
      onSave({ ...item, price: Math.round(numericValue * 100) / 100 });
    }
    onClose();
  };

  return ReactDOM.createPortal(
    <div className={`modal-overlay${isRTL ? ' rtl' : ''}`} onClick={onClose}>
      <div className="edit-item-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isRTL ? item.name_ar : item.name}</h3>
          <h4>
            {mode === 'quantity'
              ? t('cashier.cart.editQuantity')
              : t('cashier.cart.editPrice')}
          </h4>
        </div>
        <NumericKeypad
          value={value}
          onChange={setValue}
          onSubmit={handleSubmit}
          maxLength={mode === 'quantity' ? 3 : 10}
        />
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            {t('common.actions.cancel')}
          </button>
          <button className="save-btn" onClick={handleSubmit}>
            {t('common.actions.save')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EditItemModal;
